export type HorizonColorStyle = 'warm' | 'cool'

/** Build-time Style A (warm) / Style B (cool). Default cool per TASKS_TEMPLATE. */
export const HORIZON_COLOR_STYLE = 'cool' satisfies HorizonColorStyle
